"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DigitSeparators = void 0;
exports.DigitSeparators = {
    dot: ".",
    comma: ",",
    blank: " ",
    none: "",
};
//# sourceMappingURL=digitSeparators.js.map